"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Functions = require("../core/Functions");

var _Style = require("../core/Style");

var _Color = require("../core/Color");

var _colors = require("HubStyleTokens/colors");

var _LightboxConstants = require("./LightboxConstants");

var _UIDialogCloseButton = _interopRequireDefault(require("../dialog/UIDialogCloseButton"));

var _UIDialogFooter = _interopRequireDefault(require("../dialog/UIDialogFooter"));

var _UIImage = _interopRequireDefault(require("../image/UIImage"));

var _UIModal = _interopRequireDefault(require("../dialog/UIModal"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    height: 100%;\n    margin: auto;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    background-color: ", ";\n    color: inherit;\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  bottom: 0;\n  color: inherit;\n  position: absolute;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    display: block;\n    height: 100%; /* needed to account for overly tall images */\n    padding: ", ";\n    word-wrap: break-word;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledModalBody = _styledComponents.default.div.withConfig({
  displayName: "UILightbox__StyledModalBody",
  componentId: "dvio0c-0"
})(_templateObject(), (0, _Style.remCalc)(_LightboxConstants.LIGHTBOX_PADDING));

var FooterWrapper = _styledComponents.default.div.withConfig({
  displayName: "UILightbox__FooterWrapper",
  componentId: "dvio0c-1"
})(_templateObject2());

var LightboxFooter = (0, _styledComponents.default)(_UIDialogFooter.default).withConfig({
  displayName: "UILightbox__LightboxFooter",
  componentId: "dvio0c-2"
})(_templateObject3(), (0, _Color.rgba)(_colors.PANTERA, 0.89), (0, _Style.remCalc)(_LightboxConstants.LIGHTBOX_PADDING), (0, _Style.remCalc)(_LightboxConstants.LIGHTBOX_PADDING));
var LightboxImage = (0, _styledComponents.default)(_UIImage.default).withConfig({
  displayName: "UILightbox__LightboxImage",
  componentId: "dvio0c-3"
})(_templateObject4());

var DefaultFooterComponent = function DefaultFooterComponent(props) {
  var children = props.children;
  return _react.default.createElement(LightboxFooter, {
    align: "between",
    layout: "default"
  }, children);
};

var UILightbox = _react.default.createClass({
  displayName: "UILightbox",
  propTypes: {
    children: _react.PropTypes.node,
    closeable: _react.PropTypes.bool.isRequired,
    FooterComponent: RenderProp.getPropType(_UIDialogFooter.default),
    ImageComponent: RenderProp.getPropType(_UIImage.default),
    imageAlt: _react.PropTypes.string,
    imageSrc: _react.PropTypes.string,
    onClose: _react.PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      closeable: true,
      FooterComponent: DefaultFooterComponent,
      ImageComponent: LightboxImage
    };
  },
  handleCloseButtonClick: function handleCloseButtonClick(evt) {
    var onClose = this.props.onClose;
    (0, _Functions.callIfPossible)(onClose, evt);
  },
  renderCloseButton: function renderCloseButton(_ref) {
    var closeable = _ref.closeable;
    if (!closeable) return null;
    return _react.default.createElement(_UIDialogCloseButton.default, {
      size: "lg",
      detached: true,
      onClick: this.handleCloseButtonClick
    });
  },
  renderFooter: function renderFooter(_ref2) {
    var children = _ref2.children,
        FooterComponent = _ref2.FooterComponent;
    if (!children) return null;
    return _react.default.createElement(FooterComponent, null, children);
  },
  renderImage: function renderImage(_ref3) {
    var ImageComponent = _ref3.ImageComponent,
        imageAlt = _ref3.imageAlt,
        imageSrc = _ref3.imageSrc;

    if (imageSrc && !imageAlt) {
      _devLogger.default.warn({
        message: 'UILightbox: for better accessibility, please include a description ' + 'of the image in the `imageAlt` prop .',
        key: 'UILightbox: missing imageAlt prop'
      });
    }

    return _react.default.createElement(ImageComponent, {
      alt: imageAlt,
      objectFit: "contain",
      src: imageSrc
    });
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        closeable = _this$props.closeable,
        FooterComponent = _this$props.FooterComponent,
        imageAlt = _this$props.imageAlt,
        ImageComponent = _this$props.ImageComponent,
        imageSrc = _this$props.imageSrc,
        onClose = _this$props.onClose,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "closeable", "FooterComponent", "imageAlt", "ImageComponent", "imageSrc", "onClose"]);
    return _react.default.createElement(_UIModal.default, (0, _extends2.default)({}, rest, {
      use: "lightbox"
    }), this.renderCloseButton({
      closeable: closeable,
      onClose: onClose
    }), _react.default.createElement(StyledModalBody, null, this.renderImage({
      ImageComponent: ImageComponent,
      imageAlt: imageAlt,
      imageSrc: imageSrc
    })), _react.default.createElement(FooterWrapper, null, this.renderFooter({
      children: children,
      FooterComponent: FooterComponent
    })));
  }
});

var _default = UILightbox;
exports.default = _default;
module.exports = exports.default;